export const ORIGINAL_PAGE_HEIGHT = 1560;
export const REDUCED_PAGE_HEIGHT = 800;
